(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":5}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":6}],3:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":2}],4:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],5:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":12,"../../modules/es6.array.from":59,"../../modules/es6.string.iterator":61}],6:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":12,"../../modules/es6.object.assign":60}],7:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],8:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":28}],9:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":50,"./_to-iobject":52,"./_to-length":53}],10:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":11,"./_wks":57}],11:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],12:[function(require,module,exports){
var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],13:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":37,"./_property-desc":44}],14:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":7}],15:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],16:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":20}],17:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":21,"./_is-object":28}],18:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],19:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":12,"./_ctx":14,"./_global":21,"./_has":22,"./_hide":23}],20:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],21:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],22:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],23:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":16,"./_object-dp":37,"./_property-desc":44}],24:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":21}],25:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":16,"./_dom-create":17,"./_fails":20}],26:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":11}],27:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":33,"./_wks":57}],28:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],29:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":8}],30:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":23,"./_object-create":36,"./_property-desc":44,"./_set-to-string-tag":46,"./_wks":57}],31:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":19,"./_hide":23,"./_iter-create":30,"./_iterators":33,"./_library":34,"./_object-gpo":40,"./_redefine":45,"./_set-to-string-tag":46,"./_wks":57}],32:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":57}],33:[function(require,module,exports){
module.exports = {};

},{}],34:[function(require,module,exports){
module.exports = true;

},{}],35:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":20,"./_iobject":26,"./_object-gops":39,"./_object-keys":42,"./_object-pie":43,"./_to-object":54}],36:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":8,"./_dom-create":17,"./_enum-bug-keys":18,"./_html":24,"./_object-dps":38,"./_shared-key":47}],37:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":8,"./_descriptors":16,"./_ie8-dom-define":25,"./_to-primitive":55}],38:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":8,"./_descriptors":16,"./_object-dp":37,"./_object-keys":42}],39:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],40:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":22,"./_shared-key":47,"./_to-object":54}],41:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":9,"./_has":22,"./_shared-key":47,"./_to-iobject":52}],42:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":18,"./_object-keys-internal":41}],43:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],44:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],45:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":23}],46:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":22,"./_object-dp":37,"./_wks":57}],47:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":48,"./_uid":56}],48:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":12,"./_global":21,"./_library":34}],49:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":15,"./_to-integer":51}],50:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":51}],51:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],52:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":15,"./_iobject":26}],53:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":51}],54:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":15}],55:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":28}],56:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],57:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":21,"./_shared":48,"./_uid":56}],58:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":10,"./_core":12,"./_iterators":33,"./_wks":57}],59:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":13,"./_ctx":14,"./_export":19,"./_is-array-iter":27,"./_iter-call":29,"./_iter-detect":32,"./_to-length":53,"./_to-object":54,"./core.get-iterator-method":58}],60:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":19,"./_object-assign":35}],61:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":31,"./_string-at":49}],62:[function(require,module,exports){
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
    var stickyTarget = $('#stickyNav');
    stickyTarget.sticky({ topSpacing: 0, zIndex: 997 });
    stickyTarget.on('sticky-start', function () {}).on('sticky-end', function () {});

    $('div#stickyNav').on('click', "li.nav-item a", function (e) {
        var anchor = $(this);
        $('div#stickyNav').find('.navbar-collapse.collapse.in').removeClass('in');

        $('html, body').stop().animate({
            scrollTop: $(anchor.attr('href')).offset().top - 65
        }, 300);
        e.preventDefault();
    });

    $('.rating-box.star').raty({
        readOnly: true,
        starOn: "fas fa-star",
        starType: 'i'
    });
    $('.rating-box.round').raty({
        readOnly: true,
        starOn: "fas fa-circle",
        starType: 'i'
    });
    var highlightsSwiper = new Swiper('.highlight-gallery .swiper-container', {
        preloadImages: false,
        lazy: true,
        watchSlidesVisibility: true,
        spaceBetween: 0,
        loop: true,
        loopFillGroupWithBlank: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        freeMode: true,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next'
        },
        on: {
            slideChange: function slideChange() {
                var curEl = this.slides[this.activeIndex];
                var id = $(curEl).data('highlight-id');
                vm.changeCurrentHighlight(id);
            }
        }
    });
});

Vue.component('multi-select', window.VueMultiselect.default);

serverData['months'] = [].concat((0, _toConsumableArray3.default)(Array(24).keys())).map(function (value, index) {
    return moment().add(index, 'M').format('MMM YYYY');
});

var vm = new Vue({
    el: '#productsSection',
    data: function data() {
        return serverData;
    },
    computed: {
        isCityStayProduct: function isCityStayProduct() {
            return (this.product.hotel_id ? true : false) && (this.object_get(this.product, 'city_stay_hotel.id', '') ? true : false);
        },
        citiesList: function citiesList() {
            return this.product.cities.map(function (c) {
                return c.name;
            }).join(' - ');
        },
        hotelList: function hotelList() {
            var _this = this;

            if (this.product && this.isNotEmptyArray(this.product['product_itineraries'])) {
                return this.product.product_itineraries.reduce(function (c, it) {
                    if (it.hotel_id) {
                        var hotel = (0, _extends3.default)({}, it.hotel);
                        hotel.name = _this.getHotelCompiledName(hotel.name);
                        c.push(hotel);
                    }
                    return c;
                }, []);
            }
            return [];
        },
        validDates: function validDates() {
            var _this2 = this;

            if (this.isNotEmptyArray(this.product.departure_dates)) {
                return this.product.departure_dates.filter(function (date) {

                    var isTheMonths = true;
                    var isAvailable = true;
                    if (_this2.isNotEmptyArray(_this2.selectedMonths)) {
                        isTheMonths = _this2.selectedMonths.some(function (month) {
                            return moment(date.departure_date).format('MMM YYYY') === month;
                        });
                    }

                    isAvailable = moment().add(_this2.product.available_period, 'd').isSameOrBefore(date.departure_date);

                    return isTheMonths && isAvailable;
                });
            }
            return [];
        },
        productHotelInclusions: function productHotelInclusions() {
            return this.object_get(this.product, 'tags', []);
        },
        currentItinerary: function currentItinerary() {
            var _this3 = this;

            if (this.curItineraryIndex >= 0 && this.curItineraryIndex < this.product.product_itineraries.length) return this.product.product_itineraries.find(function (it, i) {
                return i === _this3.curItineraryIndex;
            });
            return {};
        },
        pricePerPerson: function pricePerPerson() {
            return this.product.regular_price || 0;
        },
        priceSumUpPerPerson: function priceSumUpPerPerson() {
            return Number(this.pricePerPerson) + Number(this.deCityCharge) + Number(this.productSeasonalCharge);
        },
        total: function total() {
            var price = Number(this.pricePerPerson) + Number(this.deCityCharge) + Number(this.seasonalTotalCharge);
            if (this.preExtensionId) {
                price += this.preExtension.land_only_price || 0;
            }
            if (this.postExtensionId) {
                price += this.postExtension.land_only_price || 0;
            }

            return price * this.paxNo;
        },
        totalDeposit: function totalDeposit() {
            var deposit = (this.product.allow_deposit ? this.product.deposit : this.product.regular_price) || 0;
            if (this.preExtensionId) {
                deposit += this.preExtension.allow_deposit ? this.preExtension.land_only_deposit : this.preExtension.land_only_price || 0;
            }
            if (this.postExtensionId) {
                deposit += this.postExtension.allow_deposit ? this.postExtension.land_only_deposit : this.postExtension.land_only_price || 0;
            }
            return this.paxNo * deposit;
        },
        shouldDeposit: function shouldDeposit() {
            var shouldDep = this.product.allow_deposit;
            if (this.preExtensionId) {

                shouldDep = this.preExtension.allow_deposit || shouldDep;
            }
            if (this.postExtensionId) {

                shouldDep = this.postExtension.allow_deposit || shouldDep;
            }
            return shouldDep;
        },
        totalItineraryDays: function totalItineraryDays() {
            if (this.product.product_itineraries) return this.product.product_itineraries.length;

            return 0;
        },
        featureFancyBoxCollection: function featureFancyBoxCollection() {
            var flatArr = null;
            if (this.product && this.product.signature_features) {
                flatArr = this.product.signature_features.reduce(function (c, feat) {
                    if (feat.image && Array.isArray(feat.image)) {
                        var arr = feat.image.map(function (img) {
                            return {
                                src: encodeURI(img),
                                opts: {
                                    // caption:'
                                    thumb: encodeURI(img)
                                }
                            };
                        });
                        c[feat.id] = arr;
                    }
                    return c;
                }, {});
            }

            return flatArr;
        }
    },
    watch: {
        selectedMonths: function selectedMonths() {
            this.selectedDateId = '';
        }
    },
    created: function created() {
        this.availabilityLoadingLength += this.perLoad;
        if (this.product.sku) {
            this.loadReviews();
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.loadScrollWatcher();
        if ($('#navMark').length) {
            $('#navMark').text($('#product-info-nav').find('.nav-item.active').find('a').text() || '');
        }

        $('#finePrintBlock .block').on('show.bs.collapse', function () {
            $(this).find('.fa-angle-down').addClass('fa-rotate-180');
        }).on('hide.bs.collapse', function () {
            $(this).find('.fa-angle-down').removeClass('fa-rotate-180');
        });

        $('#finePrintBlock').find('.block').eq(0).find('.panel-collapse').addClass('in').trigger('show.bs.collapse');

        var loginForm = $('#loginForm');
        loginForm.validate({
            rules: {
                username: {
                    required: true,
                    email: true,
                    "remote": {
                        url: '/auth/check-activation',
                        type: "post",
                        data: {
                            email: function email() {
                                return $('input[name="username"]').val();
                            }
                        }
                    }
                },
                password: {
                    required: true,
                    minlength: 8
                }
            },
            messages: {
                username: {
                    required: "Please enter your email address.",
                    email: "Please enter a valid email address."
                    // remote: jQuery.validator.format("{0} is not yet activated.")
                }
            }
        });

        this.getCurrentQuickLinkPos($(window).scrollTop() + 90);

        $('.zoom-img-display').on('click', function (e) {
            var tar = $(e.target).data('galleryTarget');
            $.fancybox.open(_this4.featureFancyBoxCollection[tar], {
                image: {
                    preload: true
                },
                toolbar: 'auto',
                thumbs: {
                    autoStart: true,
                    axis: 'x'
                },
                btnTpl: {
                    arrowLeft: '<button data-fancybox-prev class="signature-button fancybox-button fancybox-button--arrow_left" title="PREV">' + '<div><i class="fas fa-chevron-left"></i></div>' + "</button>",
                    arrowRight: '<button data-fancybox-next class="signature-button fancybox-button fancybox-button--arrow_right" title="NEXT">' + '<div><i class="fas fa-chevron-right"></i></div>' + "</button>"
                }
            });
        });
    },

    methods: {
        changeCurrentHighlight: function changeCurrentHighlight(id) {
            this.curHighlight = (0, _extends3.default)({}, this.product.highlights.find(function (h) {
                return h.id == id;
            }));
        },
        slicedItems: function slicedItems(item, length) {
            return item.slice(0, length);
        },
        endDate: function endDate(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dateFormats.yearToDay;

            if (date) {
                return moment(date, format).add(this.product.length - 1, 'd');
            }
            return '';
        },
        calculatedPrice: function calculatedPrice(val) {
            var total = Number(val || 0) + Number(this.object_get(this.available, 'surcharge'));
            return total.toFixed(2);
        },
        searchDates: function searchDates() {
            this.selectedMonths = this.tmpMonths;
            //                this.selectedYear = this.tmpYear;
        },
        clickDate: function clickDate(id) {
            var _this5 = this;

            this.selectedDateId = id;
            if (this.selectedDateId) {
                var travelDate = this.validDates.find(function (date) {
                    return date.id == _this5.selectedDateId;
                });
                if (travelDate) {
                    this.travelDate = travelDate.departure_date;
                    this.$nextTick(function () {
                        _this5.openLoginModal();
                    });
                }
            }
        },
        compiledItineraries: function compiledItineraries(it) {
            if (it) {
                return it.replace(/\[Bus\]/g, "<i class='fas fa-bus'></i>").replace(/\[Plane\]/g, "<i class='fas fa-plane'></i>").replace(/\[Train\]/g, "<i class='fas fa-train'></i>").replace(/\[Ship\]/g, "<i class='fas fa-ship'></i>");
            }
            return '';
        },
        showAllItinerary: function showAllItinerary() {
            $('#itineraryModal').modal('show').on('shown.bs.modal', function () {
                $('#itModalBody').slimScroll({
                    height: '75vh'
                });
            });
        },
        stGoNextItinerary: function stGoNextItinerary() {
            this.curItineraryIndex++;
        },
        stGoPrevItinerary: function stGoPrevItinerary() {
            this.curItineraryIndex--;
        },
        compiledHotelIntroduction: function compiledHotelIntroduction(intro) {
            if (intro) return intro.replace(/\[Mark\]/g, '<i class="fas fa-map-marker-alt"></i>');

            return '';
        },
        showMoreAvailabilities: function showMoreAvailabilities() {
            this.availabilityLoadingLength += this.perLoad;
        },
        makeBookingAsGuest: function makeBookingAsGuest() {
            var _this6 = this;

            // this.loginModal = false;

            this.$nextTick(function () {
                _this6.makeBooking();
                $('#loginModal').modal('hide');
            });
        },
        loadReviews: function loadReviews() {
            var _this7 = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var params = { sku: this.product.sku };
            params['only_reviews'] = 1;
            if (page) {
                params['page'] = page;
            }
            this.isLoadingReviews = true;
            $.get('/product/reviews', params).then(function (data) {
                if (data) {
                    if (data.reviews.reviews.length > 0) {
                        _this7.productFeefo = data.reviews;
                        _this7.concatedFeefoReviews = [].concat((0, _toConsumableArray3.default)(_this7.concatedFeefoReviews), (0, _toConsumableArray3.default)(_this7.productFeefo.reviews));
                    }
                    _this7.curReviewPage = data.reviews.summary.meta.current_page;
                    _this7.maxReviewPage = data.reviews.summary.meta.pages;

                    if (_this7.productFeefo && _this7.productFeefo.reviews.length) {
                        _this7.$nextTick(function () {
                            if (data.schema_content) {
                                $('#tab_review').append(data.schema_content);
                            }
                            $('#feefoPanelBody').slimScroll({
                                height: '450px'
                            });
                            $('#feefoPanelBody').scroll(function (e) {
                                e.stopPropagation();
                                var winTop = document.getElementById('feefoPanelBody').scrollTop,
                                    clientHeight = document.getElementById('feefoPanelBody').clientHeight,
                                    totalHeight = document.getElementById('feefoPanelBody').scrollHeight;
                                var scrollTrigger = 0.75;

                                if (winTop + clientHeight / totalHeight >= scrollTrigger) {
                                    if (!_this7.isLoadingReviews && _this7.curReviewPage < _this7.maxReviewPage) {
                                        _this7.loadReviews(_this7.curReviewPage + 1);
                                    }
                                }
                            });
                        });
                    }
                }
            }, function (xhr, status, statusText) {
                if (xhr.status != 401) {

                    console.log({ msg: statusText });
                }
            }).always(function () {
                _this7.isLoadingReviews = false;
            });
        },
        goToPage: function goToPage(page) {
            this.loadReviews(page);
        },
        getCustomerName: function getCustomerName(review) {
            if (review.customer) {
                return this.object_get(review, 'customer.display_name');
            } else {
                return 'Trusted Customer';
            }
        },
        getProductRatingsComponent: function getProductRatingsComponent(review) {
            var rating = this.getReviewRating(review);
            var str = '';
            for (var i = 0; i < 5; i++) {
                if (i < rating) {
                    str += '<i class="fas fa-star "></i>';
                } else {
                    str += '<i class="far fa-star"></i>';
                }
            }
            return str;
        },
        getTimeFromNow: function getTimeFromNow(review) {
            var productEntity = this.getProductEntity(review);
            var time = moment(productEntity.created_at);
            return time.fromNow();
        },
        getReview: function getReview(review) {
            var productEntity = this.getProductEntity(review);
            return productEntity.review;
        },
        getReviewRating: function getReviewRating(review) {
            var productEntity = this.getProductEntity(review);
            return productEntity.rating.rating;
        },
        sortedReviews: function sortedReviews(reviews) {
            var _this8 = this;

            return [].concat((0, _toConsumableArray3.default)(reviews)).sort(function (a, b) {
                return _this8.getReviewRating(b) - _this8.getReviewRating(a);
            });
        },
        getProductEntity: function getProductEntity(review) {
            return review.products[0];
        },
        makeBooking: function makeBooking() {
            // let url = '{{route('site::product_book',['slug'=>$product->slug,'id'=>$product->id])}}';
            var url = '/products/' + this.product.slug + '/' + this.product.id + '/book';

            if (this.travelDate) {
                url += '?' + $.param({
                    travel_date: this.travelDate
                });
            }
            document.location.href = url;
        },
        openLoginModal: function openLoginModal() {
            if (!this.hasLogin) {
                $('#loginModal').modal('show');
                var observer = lozad(); // lazy loads elements with default selector as '.lozad'
                observer.observe();
            } else {
                this.makeBooking();
            }
        },
        submitLogin: function submitLogin() {
            var _this9 = this;

            // if((!this.errors.first('email')) && (!this.errors.first('password'))){
            if ($('#loginForm').valid()) {
                this.isSendingForm = true;
                var form = $('#loginForm');
                var formData = form.serializeArray().reduce(function (carry, item) {
                    carry[item.name] = item.value;
                    return carry;
                }, {});
                formData.flash_login = 1;
                var route = form.attr('action');
                $.post(route, formData, function () {}).then(function (data) {
                    //console.log(data);
                    if (!data.success) {
                        noty({ layout: 'center', type: data.success ? 'success' : 'error', text: data.msg });
                    } else {
                        _this9.hasLogin = true;
                        _this9.makeBooking();
                        _this9.$nextTick(function () {
                            $('#loginModal').modal('hide');
                        });
                    }
                }).always(function () {
                    _this9.isSendingForm = false;
                });
            }
        },
        loadScrollWatcher: function loadScrollWatcher() {
            var that = this;
            $(window).scroll(function () {
                var fromTop = $(this).scrollTop() + 90;
                that.getCurrentQuickLinkPos(fromTop);
            });
        },
        getSeasonalExtra: function getSeasonalExtra() {
            var pre_extension_id = this.preExtensionId,
                pre_extension_date = this.preExtensionDate,
                post_extension_id = this.postExtensionId,
                post_extension_date = this.postExtensionDate;
            return $.get('/product-seasonal-charge',
            // '{{route('site::product_seasonal_surcharge')}}',
            {
                pre_extension_id: pre_extension_id,
                pre_extension_date: pre_extension_date,
                post_extension_id: post_extension_id,
                post_extension_date: post_extension_date
            });
        },
        getSignatureHotelStarComponent: function getSignatureHotelStarComponent(stars) {
            var str = '';
            for (var i = 0; i < stars; i++) {
                str += '<i class="fas fa-star "></i>';
            }return str;
        },
        getHotelCompiledName: function getHotelCompiledName(hotel) {
            if (hotel && hotel != 'N/A') {
                hotel += ' or similar';
            }

            return hotel;
        },
        productValidImg: function productValidImg(img) {
            if (!img) {
                return this.validImg(this.product.map || this.product.card_img);
            }
            return img;
        },
        getCurrentQuickLinkPos: function getCurrentQuickLinkPos(fromTop) {
            var lastId = void 0;
            var menuItems = $('#stickyNav').find("li.nav-item a");
            var scrollItems = menuItems.map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
            var cur = scrollItems.filter(function () {
                if ($(this).get(0).offsetTop < fromTop) return true;
            });
            if (cur.length != 0) {
                cur = cur[cur.length - 1];
            } else {
                cur = scrollItems[0];
            }

            var id = cur && cur.length ? cur[0].id : "";

            if (lastId !== id) {
                lastId = id;
                // Set/remove active class
                menuItems.parent().removeClass("active").end().filter("[href='#" + id + "']").parent().addClass("active");

                if ($('#navMark').length) {
                    $('#navMark').text($('#product-info-nav').find('.nav-item.active').find('a').text() || '');
                }
            }
        }
    },

    filters: {
        weekday: function weekday(val) {
            return moment(val).format('ddd');
        },
        formattedDate: function formattedDate(val) {
            if (val) return moment(val).format('DD/MM/YYYY');
            return '';
        },
        tableDisplayedPrice: function tableDisplayedPrice(val) {
            return '$' + Number(val || 0).toLocaleString('en') + ' per person';
        }
    }
});

},{"babel-runtime/helpers/extends":3,"babel-runtime/helpers/toConsumableArray":4}]},{},[62]);
